var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconGuide = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M12 22a9.6 9.6 0 0 0-2.6-1.475A8.2 8.2 0 0 0 6.5 20q-1.05 0-2.063.275a9 9 0 0 0-1.937.775q-.526.275-1.012-.025A.97.97 0 0 1 1 20.15V4.1q0-.274.137-.525A.86.86 0 0 1 1.55 3.2q1.15-.6 2.4-.9T6.5 2A10.8 10.8 0 0 1 12 3.5 10.8 10.8 0 0 1 17.5 2q1.3 0 2.55.3t2.4.9q.274.125.413.375.137.25.137.525v16.05a.97.97 0 0 1-.488.875q-.487.3-1.012.025a9 9 0 0 0-1.938-.775A7.8 7.8 0 0 0 17.5 20q-1.5 0-2.9.525T12 22"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  fillRule: "nonzero",
  d: "M13 19.05q1.099-.525 2.213-.788a10.3 10.3 0 0 1 4.05-.113q.863.151 1.737.451V4.7a8.7 8.7 0 0 0-1.712-.525 9.2 9.2 0 0 0-4.113.125q-1.15.3-2.175.9zM6.5 18a10 10 0 0 1 2.287.262q1.113.263 2.213.788V5.2q-1.024-.6-2.175-.9a9.2 9.2 0 0 0-4.112-.125A8.7 8.7 0 0 0 3 4.7v13.9q.875-.3 1.737-.45Q5.601 18 6.5 18"
})))));
export default SvgIconGuide;